import { faPaperclip } from '@fortawesome/pro-solid-svg-icons/faPaperclip';
import { Button, ColourStateSolid } from '@ukpostbox/frontend-framework';
import { FormProvider, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useState } from 'react';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { RenderBatchSectionType } from '../../Types/ForwardingBatchTypes';
import { AddDocumentToBatchModal } from '../Modals/AddDocumentToBatchModal';
import { BatchDocumentsComplete } from './BatchDocumentsComplete';
import { BatchDocumentsEntries } from './BatchDocumentEntries';

function BatchDocuments(props: RenderBatchSectionType) {
	const [addDocumentModalOpen, setAddDocumentModalOpen] = useState<boolean>(false);
	const { currentBatchData, RemoveDocumentFromBatch } = useForwardingBatchProvider();

	const formMethods = useForm({
		defaultValues: {
			shippingDocuments: currentBatchData?.shippingDocuments,
		},
		mode: 'onChange',
	});

	const HandleRemoveDocument = (documentId: any) => {
		RemoveDocumentFromBatch(documentId);
	};

	if (props.complete) return <BatchDocumentsComplete {...props} />;

	return (
		<FormProvider {...formMethods}>
			<div>
				<h5 className='mb-xs'>
					{`Step ${props.sectionIndex}: ${props.section.name}`}{' '}
					{props.section.isOptional ? <span className='fade'>(Optional)</span> : ''}
				</h5>

				<p>You can provide us with documents that will help us ship your batch.</p>

				<BatchDocumentsEntries {...props} removeDocumentCallback={(id) => HandleRemoveDocument(id)} />

				<Button
					title='Attach Document'
					icon={faPaperclip}
					colour={ColourStateSolid.Primary}
					fullWidth
					onClick={() => setAddDocumentModalOpen(true)}
					disabled={props.readOnly}
				/>

				<AddDocumentToBatchModal
					isOpen={addDocumentModalOpen}
					closeCallback={() => setAddDocumentModalOpen(false)}
				/>
			</div>
		</FormProvider>
	);
}

export { BatchDocuments };
